import { classes } from 'html-classes';
import { type MouseEvent, useMemo } from 'react';

import { company } from '~/company/Company';

import Icons from '../../assets/img/icons.svg';
import LocaleeIcons from '../../assets/localeeIcons/icons.svg';
import { ICON_TYPES_NOT_TRL, type IconTypes } from './IconTypes';

// Icons that exist only in the legacy LocaleeIcons sprite and have no
// counterpart in the v3 sprite — render them from LocaleeIcons regardless
// of newDesignSystemEnabled to avoid empty placeholders.
const LEGACY_ONLY_ICONS = new Set<IconTypes>(['pack', 'wallet', 'timer']);

export interface IconProps {
  type: IconTypes;
  className?: string;
  size?: number;
  width?: number;
  height?: number;
  styleVars?: React.CSSProperties & { [key: string]: string };

  onClick?(event: MouseEvent): void;
}

const Icon = ({
  className,
  size = 20,
  type,
  height,
  width,
  styleVars = {},
  onClick,
}: IconProps) => {
  const IconsToRender = useMemo(() => {
    if (LEGACY_ONLY_ICONS.has(type)) {
      return LocaleeIcons;
    }
    if (company.newDesignSystemEnabled) {
      return Icons;
    } else {
      return LocaleeIcons;
    }
  }, [type]);

  return (
    <svg
      data-company={company.name}
      role="icon"
      width={width || size}
      height={height || size}
      onClick={onClick}
      className={classes([
        `icon icon-${type}`,
        ICON_TYPES_NOT_TRL.includes(type) && 'not_rotate',
        className,
      ])}
      style={styleVars}
    >
      <use
        href={`${IconsToRender}#${type}`}
        width={width || size}
        height={height || size}
      />
    </svg>
  );
};

export default Icon;
